/**
 * Returns whether the value is a plain object.
 *
 * @param {any} value
 * @returns {boolean}
 */
function isPlainObject(value) {
  return value != null && typeof value === 'object' && !Array.isArray(value)
}

/**
 * Removes undefined values so that analytics payloads stay clean.
 *
 * @param {Record<string, any>} params
 * @returns {Record<string, any>}
 */
function compactParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined)
  )
}

export { isPlainObject, compactParams }
